module.exports = __webpack_public_path__ + "asset/image-Bed-1-4482756185974a50.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/Bed-1.svg
// module id = xb/H
// module chunks = 0